var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 20,
    viewBox: "0 0 10 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.22859 19.9152C7.02005 20.4568 9.43653 18.3319 9.43653 15.6238C9.43653 14.2073 8.72825 12.9157 7.645 12.1241V2.58314C7.645 1.16658 6.52008 0 5.06186 0C3.6453 0 2.47872 1.16658 2.47872 2.58314V12.1241C1.18715 13.0823 0.437209 14.7072 0.812181 16.5404C1.14549 18.207 2.52039 19.5819 4.22859 19.9152ZM3.02035 12.9157L3.39532 12.624V2.6248C3.39532 1.7082 4.14526 0.999925 5.0202 0.999925C5.93679 0.999925 6.68674 1.74987 6.68674 2.6248V12.624L7.06171 12.9157C7.93664 13.5406 8.43661 14.5822 8.43661 15.6655C8.43661 16.5821 8.06163 17.457 7.43668 18.082C6.77007 18.7069 5.93679 19.0819 5.0202 19.0819C3.31199 19.0819 1.97876 17.8736 1.68712 16.3738C1.4788 14.9989 1.97876 13.6656 3.02035 12.9157Z",
    fill: "#4FD1DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.06231 18.082C5.72893 18.082 6.35388 17.832 6.81218 17.3737C7.27048 16.9154 7.52046 16.2905 7.52046 15.6239C7.52046 13.9573 6.1039 13.4157 5.72893 13.0824V6.04126H4.35403V13.0824C4.06239 13.4157 2.22919 14.0823 2.64583 16.1238C2.85415 17.2071 3.81241 18.082 5.06231 18.082Z",
    fill: "#4FD1DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemp);
export default __webpack_public_path__ + "static/media/temp.703f8e65b7160fbfffa6196c5483183b.svg";
export { ForwardRef as ReactComponent };